/**
 * 处理http响应
 */
import {message} from "antd";

/**
 * 处理http响应
 * @param request 请求promise
 * @param successCallBack 成功回调
 * @param failMsg 失败消息
 * @param loadingCallback 加载中回调
 */
export const handleResponse = (request, successCallBack, failMsg, loadingCallback) => {
    loadingCallback && loadingCallback(true);
    return request.then(json => {
        if(json.code === 0){
            successCallBack(json.data);
        }else{
            if(failMsg instanceof  Object){
                message.error({...failMsg, content: json.msg});
            }else{
                message.error(json.msg);
            }
        }
    }).catch(e => {
        if(failMsg instanceof  Object){
            console.error(failMsg.content + ":" + e);
            console.error(failMsg.content + ":" + e);
            message.error(failMsg);
        }else{
            console.error(failMsg + ":" + e);
            message.error(failMsg);
        }
    }).then(() => loadingCallback && loadingCallback(false));
};

export const handleResponseNormal = (request, successCallBack, failMsg, loadingCallback) => {
    loadingCallback && loadingCallback(true);
    return request.then(json => {
        if(json.code === 0 || json.code === "200" || json.code === 200 || json.code === undefined){
            successCallBack(json);
        }else{
            if(failMsg instanceof  Object){
                message.error({...failMsg, content: json.msg});
            }else{
                message.error(json.msg);
            }
        }
    })
};
